import { FC, useMemo } from "react";

import Image from "next/image";
import Link from "next/link";

import { Button } from "antd";

import cx from "classnames";

import emptyStateIllustration2 from "@/assets/empty-illustration-2.png";

import useMilken from "@/hooks/useMilken";

import { emptyWordingData } from "./empty-state-data";
import { useRouter } from "next/router";
import { DiamondWhite } from "@/assets/icons";

import classNames from "classnames";
import { useIsViewAsHR } from "@/hooks/useIsViewAsHR";

export type whichErrorEmptyProps =
  | "dashboard-recommendedConnection"
  | "dashboard-recommendedEvent"
  | "dashboard-endorsement"
  | "dashboard-recommendedCircle"
  | "notification-invitationEndorsements-circle"
  | "notification-invitationEndorsements-events"
  | "notification-invitationEndorsements-endorsements"
  | "notification-invitationEndorsements-connections"
  | "notification-invitationEndorsements-circleofChampion"
  | "notification-invitationEndorsements-relationshipUpgrades"
  | "notification-recommendedResources-circle"
  | "notification-recommendedResources-events"
  | "notification-recommendedResources-connections"
  | "notification-skillVerificationRequest"
  | "notification-skillRecommendations"
  | "profile-option-fav"
  | "connections-all"
  | "connections-recommedation"
  | "connections-waves"
  | "connections-coc"
  | "connections-sponsors"
  | "connections-mentors"
  | "connections-mentees"
  | "connections-allies"
  | "circle-own"
  | "circle-invites"
  | "circle-recommend"
  | "event-own"
  | "event-invites"
  | "event-recommend"
  | "mygoals-mentor"
  | "mygoals-mentee"
  | "mygoals-sponsor"
  | "mygoals-modal-verifier-skill-tab-mentor"
  | "mygoals-modal-verifier-skill-tab-other"
  | "employeeGoals-mentor"
  | "employeeGoals-sponsor"
  | "mygoals-skill-completed"
  | "mygoals-skill-active"
  | "mygoals-skill-active-premium"
  | "mygoals-modal-add-skill-all-used"
  | "mygoals-userguide"
  | "mygoals-userguide-verifier"
  | "mycalendar-recommend-events"
  | "mycalendar-recommend-circles"
  | "connections-the-tea";

interface ErrorEmptyProps {
  which: whichErrorEmptyProps;
  isFullWidth?: boolean;
  onClick?: () => void;
  noCTA?: boolean;
}

const ErrorEmptyV2: FC<ErrorEmptyProps> = ({
  which,
  isFullWidth,
  onClick,
  noCTA,
}) => {
  const { milkenWordsConversion } = useMilken();

  const router = useRouter();
  const { isViewAsHR } = useIsViewAsHR();

  const content: {
    title: string | null;
    cta_title?: string | null;
    cta_link: string | null | (() => void);
    shallow: boolean | null;
    body: string | null;
    emptyIcon?: any;
  } = useMemo(() => {
    switch (which) {
      case "dashboard-endorsement":
        return emptyWordingData.dashboard.endorsement;
      case "dashboard-recommendedConnection":
        return emptyWordingData.dashboard.recommendedConnection;
      case "dashboard-recommendedEvent":
        return emptyWordingData.dashboard.recommendedEvent;
      case "dashboard-recommendedCircle":
        return emptyWordingData.dashboard.recommendedCircle;
      case "notification-invitationEndorsements-circle":
        return emptyWordingData.notification.invitationEndorsements.circle;
      case "notification-invitationEndorsements-events":
        return emptyWordingData.notification.invitationEndorsements.events;
      case "notification-invitationEndorsements-connections":
        return emptyWordingData.notification.invitationEndorsements.connections;
      case "notification-invitationEndorsements-circleofChampion":
        return emptyWordingData.notification.invitationEndorsements
          .circleofChampion;
      case "notification-invitationEndorsements-endorsements":
        return emptyWordingData.notification.invitationEndorsements
          .endorsements;
      case "notification-invitationEndorsements-relationshipUpgrades":
        return emptyWordingData.notification.invitationEndorsements
          .relationshipUpgrades;
      case "notification-recommendedResources-circle":
        return emptyWordingData.notification.recommendedResources.circle;
      case "notification-recommendedResources-events":
        return emptyWordingData.notification.recommendedResources.events;
      case "notification-recommendedResources-connections":
        return emptyWordingData.notification.recommendedResources.connections;
      case "notification-skillVerificationRequest":
        return emptyWordingData.notification.skillVerificationRequest;
      case "notification-skillRecommendations":
        return emptyWordingData.notification.skillRecommendations;
      case "profile-option-fav":
        return emptyWordingData.modal.optionsFave;
      case "connections-all":
        return emptyWordingData.myConnection.allConnections;
      case "connections-recommedation":
        return emptyWordingData.myConnection.recommedation;
      case "connections-waves":
        return emptyWordingData.myConnection.waves;
      case "connections-coc":
        return emptyWordingData.myConnection.circleOfChamion;
      case "connections-sponsors":
        return emptyWordingData.myConnection.sponsors;
      case "connections-mentors":
        return emptyWordingData.myConnection.mentors;
      case "connections-mentees":
        return emptyWordingData.myConnection.mentee;
      case "connections-allies":
        return emptyWordingData.myConnection.allies;
      case "circle-own":
        return emptyWordingData.myCircle.myCircle;
      case "circle-invites":
        return emptyWordingData.myCircle.yourInvites;
      case "circle-recommend":
        return emptyWordingData.myCircle.recommend;
      case "event-own":
        return emptyWordingData.myEvent.myEvent;
      case "event-invites":
        return emptyWordingData.myEvent.yourInvites;
      case "event-recommend":
        return emptyWordingData.myEvent.recommend;
      case "mygoals-mentor":
        return emptyWordingData.myGoals.mentor;
      case "mygoals-sponsor":
        return emptyWordingData.myGoals.sponsor;
      case "mygoals-modal-verifier-skill-tab-mentor":
        return emptyWordingData.myGoals.skillVerificationTabMentor;
      case "mygoals-modal-verifier-skill-tab-other":
        return emptyWordingData.myGoals.skillVerificationTabOther;
      case "employeeGoals-mentor":
        return emptyWordingData.employeeGoals.mentor;
      case "employeeGoals-sponsor":
        return emptyWordingData.employeeGoals.sponsor;
      case "mygoals-skill-active":
        return emptyWordingData.myGoals["mygoals-skill-active"];
      case "mygoals-skill-active-premium":
        return emptyWordingData.myGoals["mygoals-skill-active-premium"];
      case "mygoals-skill-completed":
        return emptyWordingData.myGoals["mygoals-skill-completed"];
      case "mygoals-modal-add-skill-all-used":
        return emptyWordingData.modal.addSkill.allUsed;
      case "mygoals-userguide":
        return emptyWordingData.modal.userguide;
      case "mygoals-userguide-verifier":
        return emptyWordingData.modal.userguideVerifier;
      case "mycalendar-recommend-events":
        return emptyWordingData.myCalendar.recommended.events;
      case "mycalendar-recommend-circles":
        return emptyWordingData.myCalendar.recommended.circles;
      case "connections-the-tea":
        return emptyWordingData.myConnection.theTea;
      default:
        return {
          body: "",
          cta_link: "",
          title: "",
          cta_title: "",
          breaklineLength: 0,
          shallow: false,
          emptyIcon: "",
        };
    }
  }, [which]);

  const isOnMyCalendar = useMemo(() => {
    return [
      "mycalendar-recommend-events",
      "mycalendar-recommend-circles",
    ].includes(which);
  }, [which]);

  const url = useMemo(() => {
    if (content?.cta_link) {
      const theUrl = content?.cta_link;
      if (
        router.asPath.includes("?") &&
        typeof content?.cta_link === "string" &&
        content?.cta_link.includes("{{asPath}}")
      ) {
        const trans = theUrl.toString().split("?").join("&");
        if (router.query[trans.split("=")[1]]) return router.asPath;
        return trans.replaceAll("{{asPath}}", router.asPath);
      } else {
        return theUrl.toString().replaceAll("{{asPath}}", router.asPath);
      }
    }
    return "/";
  }, [content?.cta_link]);

  return (
    <div className="text-center flex flex-col gap-[10px] items-center">
      {content?.emptyIcon ? (
        <Image
          src={content.emptyIcon}
          height={64}
          width={64}
          alt="empty state"
          className="inline-block"
        />
      ) : (
        <Image
          src={emptyStateIllustration2}
          height={64}
          width={64}
          alt="empty state"
          className="inline-block"
        />
      )}
      <div
        className={cx(
          "block",
          { "w-full": isFullWidth },
          { "max-w-xs lg:max-w-xl w-full": !isFullWidth }
        )}
      >
        {content?.title && (
          <p
            className={classNames(
              "font-normal text-sm lg:text-base",
              isOnMyCalendar && "max-w-[130px] sm:max-w-none"
            )}
          >
            {content.title &&
              content.title.replace(
                /colleagues/gi,
                milkenWordsConversion("colleagues", {
                  plural: true,
                  capitalize: false,
                }) || ""
              )}
          </p>
        )}
        {content?.body && (
          <p
            className="text-sm font-normal"
            dangerouslySetInnerHTML={{ __html: content?.body as string }}
          />
        )}
      </div>

      {content?.cta_link &&
        !noCTA &&
        (typeof content?.cta_link === "string" ? (
          <Link href={url} shallow={content?.shallow!}>
            <Button type="primary" onClick={onClick}>
              <div className="flex gap-2 items-center">
                {content?.cta_title}
                {!isViewAsHR && <DiamondWhite />}
              </div>
            </Button>
          </Link>
        ) : (
          <Button
            onClick={() => {
              onClick?.();
              if (typeof content.cta_link === "function") {
                content?.cta_link?.();
              }
            }}
            type="primary"
          >
            <div className="flex gap-2 items-center">
              {content?.cta_title}
              {!isViewAsHR && <DiamondWhite />}
            </div>
          </Button>
        ))}
    </div>
  );
};

export default ErrorEmptyV2;
